var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-layout',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.ailoading),expression:"ailoading"}],staticStyle:{"background":"#fff"},attrs:{"right":_vm.getDescriptionWidth}})
}
var staticRenderFns = []

export { render, staticRenderFns }